#import "../../../../../../../common/graphql/ApprovalMapFields.graphql"
query TravelAuthorizationPreviewApprovalMap($entityId: UUID!) {
  travelAuthorizationPreviewApprovalMap(
    entityId: $entityId
    orderBy: SORT_ORDER_DESC
  ) {
    nodes {
      ...ApprovalMapFields
    }
  }
}
